import type { ReactNode } from 'react';

import { PageHeader } from '../../components/PageHeader';
import { SectionTabs } from '../../components/SectionTabs';

const STOCK_NAV = [
  { to: '/stock', label: 'คงเหลือ', end: true },
  { to: '/movements', label: 'เคลื่อนไหว' },
  { to: '/transfers', label: 'โอนย้าย' },
  { to: '/goods-receive', label: 'รับเข้า' },
  { to: '/stock/adjust', label: 'ปรับสต๊อก' },
] as const;

export type StockStatusTone = 'ok' | 'warn' | 'danger' | 'neutral';

export function StockHeader({
  title,
  subtitle,
  actions,
  status,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: StockStatusTone };
}) {
  return (
    <div className="mb-6">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={actions}
        status={status}
      />
      <SectionTabs items={STOCK_NAV} label="เมนูศูนย์จัดการสต๊อก" />
    </div>
  );
}
